/** Which regions can hold a centred toast: id → the mounted element. A tiny external store. */
const anchors = new Map<string, HTMLElement>();
const listeners = new Set<() => void>();
let version = 0;

const bump = (): void => {
  version += 1;
  listeners.forEach((listener) => listener());
};

/** Registers an element under `id`; returns the cleanup. The latest registration of an id wins. */
export const registerToastAnchor = (id: string, element: HTMLElement): (() => void) => {
  anchors.set(id, element);
  bump();
  return () => {
    if (anchors.get(id) !== element) return;
    anchors.delete(id);
    bump();
  };
};

export const getToastAnchor = (id: string | null | undefined): HTMLElement | null => (id ? anchors.get(id) ?? null : null);
export const subscribeToastAnchors = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
export const getToastAnchorVersion = (): number => version;
